export default __webpack_public_path__ + "static/media/searchuserempty.b5f16dd7.svg";